'use client';

import { useTheme } from 'next-themes';
import { useEffect, useState } from 'react';
import { getThemedContent, type ThemedAsset } from '@/lib/utils';

interface ThemedIconProps {
  icon: ThemedAsset;
  alt: string;
  className?: string;
}

/**
 * Renders the theme-appropriate variant of a button icon. Small client island
 * so the surrounding feature pages can stay Server Components.
 *
 * Until mounted we render the default-theme (dark) variant deterministically:
 * `next-themes` reports `theme === undefined` during SSR but resolves to the
 * default on the client's first render, so keying the `src` off it directly
 * would cause a hydration mismatch.
 */
export function ThemedIcon({ icon, alt, className }: ThemedIconProps) {
  const { theme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  const resolved = mounted ? theme : 'dark';
  return <img src={getThemedContent(resolved, icon)} alt={alt} className={className} />;
}
